import { BroadcastChannelSync, createIdAdapter, defineSelf, defineSSO, ProfileAdapterV2, } from "@s7/profile";
var S7_ID_URL = process.env.REACT_APP_S7_ID_URL;
var PROFILE_SERVICE_URL = process.env.REACT_APP_PROFILE_SERVICE_URL;
var PROFILE_SERVICE_TOKEN = process.env.REACT_APP_PROFILE_SERVICE_TOKEN;
var APPLICATION_IDENT = process.env.REACT_APP_APPLICATION_IDENT;
export var profileAdapterV2 = ProfileAdapterV2({
    serviceUrl: PROFILE_SERVICE_URL,
    apiToken: PROFILE_SERVICE_TOKEN,
    scopes: ["id", "avatar", "basic_info", "employee", "loyalty"],
});
var reload = function () {
    window.location.reload();
};
export var Self = defineSelf({
    adapter: profileAdapterV2,
    sync: BroadcastChannelSync(),
    onExternalLogout: reload,
    onExternalDeauthorized: reload,
    onLogout: reload,
    onLogoutError: reload,
    onDeauthorized: reload,
});
export var sso = defineSSO({
    adapter: createIdAdapter({
        application: APPLICATION_IDENT,
        ssoApplicationUrl: S7_ID_URL,
    }),
});
